// Configuration

console.log('Host name:' + document.location.hostname)

if(document.location.hostname === 'localhost') {
  localStorage.setItem('apiHost', 'https://bky-api.fawful.se')
}

if(document.location.hostname === 'bky.bowser.se') {
  localStorage.setItem('apiHost', 'https://bky-api.bowser.se')
}

if(document.location.hostname === 'bky.fawful.se') {
  localStorage.setItem('apiHost', 'https://bky-api.fawful.se')
}

if(document.location.hostname === 'bky.arriva.guru' || document.location.hostname === 'https://bky-prod.arriva.guru'){
  localStorage.setItem('apiHost', 'https://bky-api.arriva.guru')
}

var apiHost = localStorage.getItem('apiHost') || document.location.protocol + '//bky-api.' + document.location.hostname.split('.').splice(-2).join('.')

console.info('apiHost: %s', apiHost)

window.globalConfig = {
  api: {
    districts: {
      path: apiHost + '/api/district'
    },
    staff: {
      path: apiHost + '/api/staff'
    },
    competence: {
      path: apiHost + '/api/competence'
    },
    competenceGroup: {
      path: apiHost + '/api/competenceGroup'
    },
    ExpectedCompetence: {
      path: apiHost + '/api/ExpectedCompetence'
    },
  },
  bky: {
    columns: {
      defaultColumns: ['B', 'D1', 'D1E', 'D', 'DE', 'YKBBuss', 'Förarkort']
    },
    order: [
      'B',
      'B96',
      'BE',
      'C1',
      'C1E',
      'C',
      'CE',
      'D1',
      'D1E',
      'D',
      'DE',
      'Förarkort'
    ]
  },
}

var app = angular.module('app', ['ui.bootstrap'])

app.config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('authInterceptor')
}])
